import { alpha, type SxProps, type Theme } from "@mui/material";

export const mint = "#1f7a4d";

/** Outlined “View cart” — matches Search / mint shell */
export const viewCartButtonSx: SxProps<Theme> = {
  textTransform: "capitalize",
  textWrap: "nowrap",
  fontSize: "12px",
  padding: "6px 14px",
  borderRadius: "999px",
  fontWeight: 600,
  borderWidth: 1,
  borderStyle: "solid",
  borderColor: alpha("#1f7a4d", 0.35),
  color: "#123524",
  "&:hover": {
    borderColor: alpha("#1f7a4d", 0.85),
    backgroundColor: alpha("#1f7a4d", 0.06),
  },
};

export const floatingAmountSx: SxProps<Theme> = {
  fontWeight: 700,
  color: mint,
};

export const floatingSaveSx: SxProps<Theme> = {
  fontWeight: 600,
  color: "#123524",
};

export const floatingCartDesktopCardSx: SxProps<Theme> = {
  position: "fixed",
  bottom: {
    xs: "calc(88px + env(safe-area-inset-bottom, 0px))",
    sm: 20,
  },
  left: { xs: "50%", sm: "auto" },
  right: { xs: "auto", sm: 140 },
  transform: { xs: "translateX(-50%)", sm: "none" },
  background: "linear-gradient(180deg, #ffffff 0%, #fafcfb 100%)",
  zIndex: 1000,
  borderRadius: "16px",
  width: { xs: "95%", sm: "26rem" },
  height: "auto",
  border: `1px solid ${alpha("#1f7a4d", 0.12)}`,
  boxShadow: "0 12px 40px rgba(18, 53, 36, 0.12)",
  cursor: "pointer",
  borderLeft: "4px solid #1f7a4d",
  overflow: "hidden",
};

/** Above MUI Drawer (often 1200–1400) so cart stays visible over search overlay */
export const floatingCartSearchMobileSx: SxProps<Theme> = {
  position: "fixed",
  display: { xs: "block", sm: "none" },
  left: 0,
  right: 0,
  bottom: "calc(var(--salontym-mobile-nav-h, 72px) + env(safe-area-inset-bottom, 0px) + 8px)",
  background: "linear-gradient(180deg, #ffffff 0%, #fafcfb 100%)",
  zIndex: 1450,
  width: "100%",
  maxWidth: "100vw",
  margin: "auto",
  height: "95px",
  borderTop: `1px solid ${alpha("#1f7a4d", 0.12)}`,
  boxShadow: "0 -8px 32px rgba(18, 53, 36, 0.1)",
  cursor: "pointer",
  borderLeft: "4px solid #1f7a4d",
};

export const floatingCartCategoryCardSx: SxProps<Theme> = {
  position: "fixed",
  bottom: {
    xs: "calc(92px + env(safe-area-inset-bottom, 0px))",
    sm: 20,
  },
  left: { xs: "50%", sm: "auto" },
  right: { xs: "auto", sm: 20 },
  transform: { xs: "translateX(-50%)", sm: "none" },
  background: "linear-gradient(180deg, #ffffff 0%, #fafcfb 100%)",
  zIndex: 1000,
  borderRadius: "16px",
  width: { xs: "95%", sm: "25rem" },
  height: "auto",
  border: `1px solid ${alpha("#1f7a4d", 0.12)}`,
  boxShadow: "0 12px 40px rgba(18, 53, 36, 0.12)",
  cursor: "pointer",
  display: { xs: "none", sm: "block" },
  borderLeft: "4px solid #1f7a4d",
  overflow: "hidden",
};
